import {
  Bestellung,
  AbholzeitType,
  Terminart,
  BPBeginnenRequest,
  RemoteResult,
  BestellungPending,
  BestellungFilialeRequest,
  BestellungList,
} from "mangdto"
import router from "@/router"
import store from "@/store"
import Poster from "@/util/poster"
import RestPaths from "@/util/rest_paths"
import RouteNames from "@/util/route_names"
import BaseLogic from "../base_logic"
import vuexStore from "@/store"

export default class AbholungStartenLogic extends BaseLogic {
  bestellungen: Bestellung[] = []

  bestellungStarten() {
    var request = new BPBeginnenRequest()
    request.filialeId = this.filiale.filialeId
    request.terminart = Terminart.Abholung
    request.direktabholung = true
    request.identifier = store.state.user.identifier

    Poster.postUser<RemoteResult<string>>(
      RestPaths.bestellungpendingBeginnen,
      request,
    ).then((response) => {
      if (response.data.success) {
        this.mainLogic.bestellungPending = new BestellungPending()
        this.mainLogic.bestellungPending.terminart = Terminart.Abholung
        this.mainLogic.bestellungPending.abholung.abholzeitType =
          AbholzeitType.Baldest
        this.mainLogic.bestellungPending.abholung.direktabholung = true

        this.mainLogic.neueBestellung = true
        router.push({ name: RouteNames.NEU.VERZEHRART })
      }
    })
  }

  init() {
    var request = new BestellungFilialeRequest()
    request.identifierId = vuexStore.state.user.identifier
    request.filialeId = this.mainLogic.filiale.filialeId

    Poster.postUser<RemoteResult<BestellungList>>(
      RestPaths.bestellungKundeFilialeAktuell,
      request,
    ).then((response) => {
      if (response.data.success) {
        this.bestellungen = response.data.payload.list
      }
    })
  }
}
